// Hook - dodanie wpisu kontaktu z klientem (telefon/email/spotkanie)
// POST /api/ui/trader/insights/clients/{clientId}/contact

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type { IPostClientContactRequest } from 'api/types/traderInsights';

export interface IPostClientContactVariables {
  clientId: number;
  data: IPostClientContactRequest;
}

type IResponse = ICommandResponseSuccess;

const postClientContact = ({ clientId, data }: IPostClientContactVariables): Promise<IResponse> =>
  axios.post(`/trader/insights/clients/${clientId}/contact`, data);

export const usePostClientContact = (
  options?: UseMutationOptions<IResponse, IError, IPostClientContactVariables>
) => useMutation((variables: IPostClientContactVariables) => postClientContact(variables), options);
